import styled from 'styled-components';

export const ConsultarComponent = styled.div.attrs({
    className: ``
})`



`